export const attendeeType = [
  { label: "Asistente", value: "ATTENDEE" },
  { label: "Beneficiario", value: "BENEFICIARY" }
]
